import { navigate } from '../navigate';
import sendEvent from './analytics-wrapper';

const trackTypeOfView = () => {
    const currentViewType = document.querySelector<HTMLElement>('.js-wio__hd')?.dataset.viewType;

    if (currentViewType !== undefined) {
        sendEvent({
            category: 'View type',
            action: currentViewType,
            label: navigate.getHref(),
        });
    }
};

export default trackTypeOfView;
